import angular from 'angular';
import assignmentsComponent from './assignments.component';
import assignmentsService from './assignments.service';

let assignmentsModule = angular.module('assignments', []).directive('assignments', assignmentsComponent).service('assignmentsService', assignmentsService);

export default assignmentsModule;



// WEBPACK FOOTER //
// ./app/components/assignments/assignments.js